import { render, staticRenderFns } from "./CompletedTA10.vue?vue&type=template&id=3ac786f2&scoped=true&"
import script from "./CompletedTA10.vue?vue&type=script&lang=js&"
export * from "./CompletedTA10.vue?vue&type=script&lang=js&"
import style0 from "./CompletedTA10.vue?vue&type=style&index=0&id=3ac786f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac786f2",
  null
  
)

export default component.exports